import { postApi } from 'api/fetchApi'
import { paths } from 'api/generated/gifts'

export const removeGiftAuthorApi = (giftId: number) =>
  postApi(`/gifts/${giftId}/hide_author` as keyof paths, {
    giftId,
  })
